import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/login";
import Home from "@/views/Home";
import Welcome from "@/views/Welcome";
import BigScreen from "@/views/bigScreen";
import TestTable from "@/views/TestTable";
import TestForm from "@/views/TestForm";

//BMS start------
//机构管理
import OrganManagement from "@/views/BMS/organManagement/operatormanagement"; //机构管理
import AddOrgan from "@/views/BMS/organManagement/addOperatormanagement"; //新增机构
import ModifyOrgan from "@/views/BMS/organManagement/modifyOperatormanagement"; //修改机构
import OrganDetail from "@/views/BMS/organManagement/operatorDetail"; //机构详情

//用户管理
import Administrators from "@/views/BMS/userManagement/administrators"; //管理员列表
import AddAdministrators from "@/views/BMS/userManagement/addAdministrators"; //新增管理员
import ReviseAdministrators from "@/views/BMS/userManagement/reviseAdministrators"; //修改管理员
import SystemManagement from "@/views/BMS/userManagement/rolemanagement"; //角色管理
import AddRole from "@/views/BMS/userManagement/addrole"; //新增角色
import ReviseRole from "@/views/BMS/userManagement/reviserole"; //修改角色

//系统管理
import SystemSetting from "@/views/BMS/systemSettings/systemSettings"; //系统设置
import FirmManagement from "@/views/BMS/firmManagement/firmManagement"; //固件管理
import FirmDownload from "@/views/BMS/firmManagement/firmUpload"; //固件管理
import FindProject from "@/views/BMS/firmManagement/findProject"; //查询项目信息数据
import DownFirmData from "@/views/BMS/deviceManagement/downFirmData"; //下发固件数据

//告警管理
import BatteryAlarm from "@/views/BMS/alarmManagement/batteryAlarm/batteryAlarm"; //电池告警列表
import BatteryAlarmDetail from "@/views/BMS/alarmManagement/batteryAlarm/BatteryAlarmDetail"; //电池告警详情
import OfflineAlarm from "@/views/BMS/alarmManagement/offlineAlarm/offlineAlarm"; //离线告警列表
import OfflineAlarmDetail from "@/views/BMS/alarmManagement/offlineAlarm/offlineAlarmDetail"; //离线告警详情
import AlarmSettings from "@/views/BMS/alarmManagement/alarmSettings/alarmSettings"; //告警设置列表
import AddAlarmSettings from "@/views/BMS/alarmManagement/alarmSettings/addAlarmSettings"; //新增告警设置
import AlarmSettingsDetail from "@/views/BMS/alarmManagement/alarmSettings/alarmSettingsDetail"; //告警设置详情
import NotifiGroupManagement from "@/views/BMS/alarmManagement/notifiGroupManagement/notifiGroupManagement"; //通知组管理列表
import AddNotifiGroup from "@/views/BMS/alarmManagement/notifiGroupManagement/addNotifiGroup"; //新增通知组
import ModifyNotifiGroup from "@/views/BMS/alarmManagement/notifiGroupManagement/modifyNotifiGroup"; //修改通知组
import NotifiGroupDetail from "@/views/BMS/alarmManagement/notifiGroupManagement/notifiGroupDetail"; //通知组详情
import NotifiAlarmRecord from "@/views/BMS/alarmManagement/notifiAlarmRecord/notifiAlarmRecord"; //告警通知记录
import AgreementManagement from "@/views/BMS/alarmManagement/agreementManagement/agreementManagement"; //协议管理列表
import AddAgreement from "@/views/BMS/alarmManagement/agreementManagement/addAgreement"; //新增协议
import agreementDetail from "@/views/BMS/alarmManagement/agreementManagement/agreementDetail"; //协议详情
import ReviseAgreement from "@/views/BMS/alarmManagement/agreementManagement/reviseAgreement"; //协议修改

//客户设备管理
import ProjectManagement from "@/views/BMS/deviceManagement/projectManagement"; //项目管理
import ModifyProject from "@/views/BMS/deviceManagement/modifyProject"; //修改项目
import AddProject from "@/views/BMS/deviceManagement/addProject"; //新增项目
import DeviceManagement from "@/views/BMS/deviceManagement/deviceManagement"; //设备管理列表
import AddDevice from "@/views/BMS/deviceManagement/addDevice"; //新增设备
import ModifyDevice from "@/views/BMS/deviceManagement/modifyDevice"; //修改设备
import HistoryData from "@/views/BMS/deviceManagement/historyData"; //历史数据
import BrandModel from "@/views/BMS/deviceManagement/brandModel"; // 品牌型号
import AddBrandModel from "@/views/BMS/deviceManagement/addBrandModel"; // 新增品牌型号
import ReviseBrandModel from "@/views/BMS/deviceManagement/reviseBrandModel"; //修改品牌型号

import RealData from "@/views/BMS/deviceManagement/realData"; //实时数据
import RealtimeQuery from "@/views/BMS/deviceManagement/realtimeQuery"; //实时数据(通用GET)

// 阈值管理
import ThresholdList from "@/views/BMS/thresholdManagement/list"; // 阈值列表
import ThresholdDetail from "@/views/BMS/thresholdManagement/detail"; // 新增阈值
import ThresholdForm from "@/views/BMS/thresholdManagement/form"; // 阈值表单
import ThresholdSetting from "@/views/BMS/thresholdManagement/thresholdSetting"; // 阈值设置
//BMS end-----
import MaintenanceMonitoring from "@/views/BMS/maintenanceMonitoring/maintenanceMonitoring"; //首页概况
import Firmware from "@/views/BMS/otaManager/firmware";
import AddFirmware from "@/views/BMS/otaManager/addFirmware";
import UpgradeRecord from "@/views/BMS/otaManager/record";
import Upgrade from "@/views/BMS/otaManager/upgrade";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/bigScreen",
      name: "BigScreen",
      component: BigScreen
    },
    {
      path: "/Welcome",
      component: Home,
      children: [
        {
          path: "",
          name: "Welcome",
          component: Welcome
        }
      ]
    },
    {
      path: "/realData",
      name: "RealData",
      component: RealData
    },
    {
      path: "/realtimeQuery",
      name: "RealtimeQuery",
      component: RealtimeQuery
    },
    // {
    //   path: "/MaintenanceMonitoring",
    //   name: "MaintenanceMonitoring",
    //   meta: {
    //     title: "监控运维",
    //     icon: "iconfont icon-yonghuguanli",
    //     permission: "Monitoringoperation",
    //     show: "true"
    //   },
    //   component: Home,
    //   children: [
    //     {
    //       path: "MaintenanceMonitoring",
    //       name: "MaintenanceMonitoring",
    //       meta: {
    //         title: "监控运维",
    //         icon: "iconfont icon-guanggao",
    //         permission: "Monitoringoperation",
    //         show: "true"
    //       },
    //       component: MaintenanceMonitoring
    //     }
    //   ]
    // },
    {
      path: "/organManagement",
      name: "organManagement",
      meta: {
        title: "机构管理",
        icon: "iconfont icon-jigouguanli",
        permission: "organizationalmanagement"
      },
      component: Home,
      children: [
        {
          path: "operatormanagement",
          name: "yunyingshangguanli",
          meta: {
            title: "机构管理",
            icon: "iconfont icon-jigouguanli02",
            permission: "organizationalmanagement.manage",
            show: "true"
          },
          component: OrganManagement
        },
        {
          path: "addOperatormanagement",
          name: "xinzengyunyingshang",
          meta: {
            title: "新增",
            icon: "iconfont icon-user-cp-menu",
            permission: "organizationalmanagement.pageadd"
          },
          component: AddOrgan
        },
        {
          path: "modifyOperatormanagement",
          name: "xiugaiyunyingshang",
          meta: {
            title: "修改",
            icon: "iconfont icon-user-cp-menu",
            permission: "organizationalmanagement.pageupdate"
          },
          component: ModifyOrgan
        },
        {
          path: "operatorDetail",
          name: "jigouxiangqing",
          meta: {
            title: "详情",
            icon: "iconfont icon-user-cp-menu",
            permission: "organizationalmanagement.pagetail"
          },
          component: OrganDetail
        }
      ]
    },
    {
      path: "/userManagement",
      name: "userManagement",
      meta: {
        title: "用户管理",
        icon: "iconfont icon-yonghuguanli",
        permission: "user.manage"
      },
      component: Home,
      children: [
        {
          path: "administrators",
          name: "guanliyuanyonghu",
          meta: {
            title: "管理员用户",
            icon: "iconfont icon-guanliyuan",
            permission: "user.manage.adminuser",
            show: "true"
          },
          component: Administrators
        },
        {
          path: "addAdministrators",
          name: "addAdministrators",
          meta: {
            title: "新增管理员",
            icon: "",
            permission: "user.manage.adminuser.pageadd"
          },
          component: AddAdministrators
        },
        {
          path: "reviseAdministrators",
          name: "reviseAdministrators",
          meta: {
            title: "修改管理员",
            icon: "",
            permission: "user.manage.adminuser.pageupdate"
          },
          component: ReviseAdministrators
        },
        {
          path: "rolemanagement",
          name: "jueseguanli",
          meta: {
            title: "角色管理",
            icon: "iconfont icon-jiaoseguanli",
            permission: "role.manage",
            show: "true"
          },
          component: SystemManagement
        },
        {
          path: "addrole",
          name: "xinzengjuese",
          meta: {
            title: "新增角色",
            permission: "role.manage.pageadd"
          },
          component: AddRole
        },
        {
          path: "reviserole",
          name: "xiugaijuese",
          meta: {
            title: "修改角色",
            permission: "role.manage.pageupdate"
          },
          component: ReviseRole
        }
      ]
    },
    {
      path: "/deviceManagement",
      name: "customerDeviceManagement",
      meta: {
        title: "客户设备管理",
        icon: "iconfont icon-shebeiguanli",
        permission: "Customerequipment"
      },
      component: Home,
      children: [
        {
          path: "projectManagement",
          name: "projectManagement",
          meta: {
            title: "项目管理",
            icon: "iconfont icon-icon-project",
            permission: "projectmanagement",
            show: "true"
          },
          component: ProjectManagement
        },
        {
          path: "addProject",
          name: "addProject",
          meta: {
            title: "新增项目",
            icon: "",
            permission: "projectmanagement.pageadd"
          },
          component: AddProject
        },
        {
          path: "modifyProject",
          name: "modifyProject",
          meta: {
            title: "修改项目",
            icon: "",
            permission: "projectmanagement.pageupdate"
          },
          component: ModifyProject
        },
        {
          path: "deviceManagement",
          name: "deviceManagement",
          meta: {
            title: "设备管理",
            icon: "iconfont icon-shebei",
            permission: "devicemanagement",
            show: "true",
            keepAlive: true
          },
          component: DeviceManagement
        },
        {
          path: "addDevice",
          name: "addDevice",
          meta: {
            title: "新增设备",
            icon: "",
            permission: "devicemanagement.pageadd"
          },
          component: AddDevice
        },
        {
          path: "modifyDevice",
          name: "modifyDevice",
          meta: {
            title: "修改设备",
            icon: "",
            permission: "devicemanagement.pageupdate"
          },
          component: ModifyDevice
        },
        {
          path: "historyData",
          name: "historyData",
          meta: {
            title: "历史数据",
            icon: "",
            permission: "devicemanagement.History"
          },
          component: HistoryData
        },
        {
          path: "downFirmData",
          name: "downFirmData",
          meta: {
            title: "固件数据下发",
            icon: "",
            permission: "devicemanagement.History"
          },
          component: DownFirmData
        },

        {
          path: "brandModel",
          name: "pinpaixinghao",
          meta: {
            title: "品牌型号",
            icon: "iconfont icon-pinpaiguanli",
            permission: "devicemanagement.brandModel", //devicemanagement.brandModel
            show: "true"
          },
          component: BrandModel
        },
        {
          path: "addBrandModel",
          name: "xinzengpinpaixinghao",
          meta: {
            title: "新增品牌型号",
            icon: "iconfont icon-zhamenxinxi",
            permission: "devicemanagement.brandModel.add"
          },
          component: AddBrandModel
        },
        {
          path: "reviseBrandModel",
          name: "xiugaipinpaixinghao",
          meta: {
            title: "修改品牌型号",
            icon: "iconfont icon-zhamenxinxi",
            permission: "devicemanagement.brandModel.update"
          },
          component: ReviseBrandModel
        }
      ]
    },

    {
      path: "/thresholdManagent",
      name: "thresholdManagent",
      meta: {
        title: "阈值管理",
        icon: "iconfont icon-yuzhi",
        permission: "threshold"
      },
      component: Home,
      children: [
        {
          path: "list",
          name: "ThresholdList",
          meta: {
            title: "阈值列表",
            icon: "iconfont icon-yuzhiliebiao",
            permission: "threshold.list",
            show: "true"
          },
          component: ThresholdList
        },
        {
          path: "add",
          name: "AddThreshold",
          meta: {
            title: "新增阈值",
            icon: "",
            permission: "threshold.add"
          },
          component: ThresholdForm
        },
        {
          path: "edit/:id",
          name: "ThresholdEdit",
          component: ThresholdForm,
          meta: {
            title: "编辑阈值",
            permission: "threshold.edit",
            icon: ""
          }
        },
        {
          path: "detail/:id",
          name: "ThresholdDetail",
          component: ThresholdDetail,
          meta: {
            title: "阈值详情",
            permission: "threshold.detail",
            icon: ""
          }
        },
        {
          path: "thresholdSetting",
          name: "thresholdSetting",
          meta: {
            title: "阈值设置",
            icon: "iconfont icon-yuzhishezhi",
            permission: "threshold.setting",
            show: "true"
          },
          component: ThresholdSetting
        }
      ]
    },

    {
      path: "/alarmManagement",
      name: "alarmManagement",
      meta: {
        title: "告警管理",
        icon: "iconfont icon-gaojingguanli",
        permission: "warning"
      },
      component: Home,
      children: [
        {
          path: "battryAlarm",
          name: "battryAlarm",
          meta: {
            title: "电池告警",
            icon: "iconfont icon-dianchigaojing",
            permission: "Batteryalarm",
            show: "true"
          },
          component: BatteryAlarm
        },
        {
          path: "batteryAlarmDetail",
          name: "batteryAlarmDetail",
          meta: {
            title: "电池告警详情",
            icon: "",
            permission: "Batteryalarm.pagedetail"
          },
          component: BatteryAlarmDetail
        },
        {
          path: "offlineAlarm",
          name: "offlineAlarm",
          meta: {
            title: "离线告警",
            icon: "iconfont icon-lixiangaojing",
            permission: "Offlinealarm",
            show: "true"
          },
          component: OfflineAlarm
        },
        {
          path: "offlineAlarmDetail",
          name: "offlineAlarmDetail",
          meta: {
            title: "离线告警详情",
            icon: "",
            permission: "Offlinealarm.pagedetail"
          },
          component: OfflineAlarmDetail
        },
        {
          path: "alarmSettings",
          name: "alarmSettings",
          meta: {
            title: "告警设置",
            icon: "iconfont icon-gaojingshezhi",
            permission: "warning.set",
            show: "true"
          },
          component: AlarmSettings
        },
        {
          path: "addAlarmSettings",
          name: "addAlarmSettings",
          meta: {
            title: "新增告警设置",
            icon: "",
            permission: "warning.set.pageadd"
          },
          component: AddAlarmSettings
        },
        {
          path: "alarmSettingsDetail",
          name: "alarmSettingsDetail",
          meta: {
            title: "告警设置详情",
            icon: "iconfont icon-zhamenxinxi",
            permission: "warning.set.pagedetail"
          },
          component: AlarmSettingsDetail
        },

        {
          path: "notifiGroupManagement",
          name: "notifiGroupManagement",
          meta: {
            title: "通知组管理",
            icon: "iconfont icon-tongzhizuguanli",
            permission: "warning.inform",
            show: "true"
          },
          component: NotifiGroupManagement
        },
        {
          path: "addNotifiGroup",
          name: "addNotifiGroup",
          meta: {
            title: "新增通知组",
            icon: "iconfont icon-zhamenxinxi",
            permission: "warning.inform.pageadd"
          },
          component: AddNotifiGroup
        },
        {
          path: "modifyNotifiGroup",
          name: "modifyNotifiGroup",
          meta: {
            title: "修改通知组",
            icon: "iconfont icon-zhamenxinxi",
            permission: "warning.inform.pageupdate"
          },
          component: ModifyNotifiGroup
        },
        {
          path: "notifiGroupDetail",
          name: "notifiGroupDetail",
          meta: {
            title: "通知组详情",
            icon: "iconfont icon-zhamenxinxi",
            permission: "warning.inform.pagedetail"
          },
          component: NotifiGroupDetail
        },
        {
          path: "notifiAlarmRecord",
          name: "notifiAlarmRecord",
          meta: {
            title: "告警通知记录",
            icon: "iconfont icon-gaojingjilu",
            permission: "Alarmnotificationrecord",
            show: "true"
          },
          component: NotifiAlarmRecord
        },
        {
          path: "agreementManagement",
          name: "agreementManagement",
          meta: {
            title: "协议管理",
            icon: "iconfont icon-xieyiguanli",
            permission: "AgreementManagement",
            show: "true"
          },
          component: AgreementManagement
        },
        {
          path: "addAgreement",
          name: "addAgreement",
          meta: {
            title: "新增协议",
            icon: "iconfont icon-zhamenxinxi",
            permission: "AgreementManagement.pageadd"
          },
          component: AddAgreement
        },
        {
          path: "agreementDetail",
          name: "agreementDetail",
          meta: {
            title: "协议详情",
            icon: "iconfont icon-zhamenxinxi",
            permission: "AgreementManagement.pagedetail"
          },
          component: agreementDetail
        },
        {
          path: "reviseAgreement",
          name: "reviseAgreement",
          meta: {
            title: "修改协议",
            icon: "iconfont icon-zhamenxinxi",
            permission: "AgreementManagement.pageupdate"
          },
          component: ReviseAgreement
        }
      ]
    },
    {
      path: "/systemManagement",
      name: "xitongguanli",
      meta: {
        title: "系统管理",
        icon: "iconfont icon-xitongguanli",
        permission: "systemm.manage"
      },
      component: Home,
      children: [
        {
          path: "systemSetting",
          name: "xitongshezhi",
          meta: {
            title: "系统设置",
            icon: "iconfont icon-xitongshezhi",
            permission: "systemm.manage",
            show: "true"
          },
          component: SystemSetting
        },
        {
          path: "firmManagement",
          name: "gujianguanli",
          meta: {
            title: "固件管理",
            icon: "iconfont icon-gujianguanli",
            permission: "firm.manage",
            show: "true"
          },
          component: FirmManagement
        },
        {
          path: "firmDownload",
          name: "gujianshangchuan",
          meta: {
            title: "固件上载",
            icon: "iconfont icon-OTAshengji",
            permission: "firm.download",
            show: "true"
          },
          component: FirmDownload
        },
        {
          path: "findProject",
          name: "findProject",
          meta: {
            title: "项目查询",
            icon: "",
            permission: "firm.download"
          },
          component: FindProject
        }
      ]
    },
    {
      path: "/ota",
      name: "OTA",
      meta: {
        title: "OTA升级",
        icon: "iconfont icon-OTAshengji",
        permission: "ota"
      },
      component: Home,
      children: [
        {
          path: "firmware",
          name: "firmware",
          meta: {
            title: "固件管理",
            icon: "iconfont icon-gujianguanli",
            permission: "ota.firm",
            show: "true"
          },
          component: Firmware
        },
        {
          path: "addFirmware",
          name: "addFirmware",
          meta: {
            title: "新增固件",
            icon: "iconfont icon-zhamenxinxi",
            permission: "ota.firmare",
            show: "true"
          },
          component: AddFirmware
        },
        {
          path: "upgrade",
          name: "upgrade",
          meta: {
            title: "设备升级",
            icon: "iconfont icon-OTAshengji",
            permission: "ota.upgrade",
            show: "true"
          },
          component: Upgrade
        },
        {
          path: "record",
          name: "record",
          meta: {
            title: "升级记录",
            icon: "iconfont icon-shengjijilu",
            permission: "ota.record",
            show: "true"
          },
          component: UpgradeRecord
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js